import { interpolateYlOrBr, interpolateYlOrRd, interpolateYlGnBu } from 'd3-scale-chromatic'

export function fillColorScaleLegend(scale: (t: number) => string, canvas?: HTMLCanvasElement | null): void {
    if (canvas) {
        const ctx = canvas.getContext('2d') as CanvasRenderingContext2D
        const { width, height } = canvas

        ctx.clearRect(0, 0, width, height)
        ctx.beginPath()

        for (let i = 0; i < width; i++) {
            ctx.fillStyle = scale((width - i) / width)
            ctx.fillRect(i, 0, 1, height)
        }

        ctx.fill()
    }
}

export const colorScaleOptions: { [key: string]: (t: number) => string } = {
    YlOrBr: interpolateYlOrBr,
    YlOrRd: interpolateYlOrRd,
    YlGnBlu: interpolateYlGnBu
}
